import * as tslib_1 from "tslib";
import { WIDTH_TO_HEIGHT_RATIO_THRESHOLD_TO_CROP_SUPER_TALL, WIDTH_TO_HEIGHT_RATIO_TO_SET_FOR_OVERSIZED, WIDTH_TO_HEIGHT_RATIO_THRESHOLD_TO_CROP_SUPER_WIDE, WIDTH_TO_HEIGHT_RATIO_TO_SET_FOR_TINY, } from '../DeviationViews/constants';
// Make massive images smaller, if the image is massive in ratio
// we simply crop it to 16/9, this creates a "fair" showing look
export var applyMassiveThumbThreshold = function (item) {
    var whRatio = item.width / item.height;
    // too tall
    if (whRatio < WIDTH_TO_HEIGHT_RATIO_THRESHOLD_TO_CROP_SUPER_TALL) {
        var extraHeight = item.height - item.width * WIDTH_TO_HEIGHT_RATIO_TO_SET_FOR_OVERSIZED;
        item.height = item.height - extraHeight;
    }
    // too wide
    if (whRatio > WIDTH_TO_HEIGHT_RATIO_THRESHOLD_TO_CROP_SUPER_WIDE) {
        var extraWidth = item.width - item.height * WIDTH_TO_HEIGHT_RATIO_TO_SET_FOR_OVERSIZED;
        item.width = item.width - extraWidth;
    }
    return item;
};
export var applyTinyThumbThreshold = function (item, targetHeight) {
    var tinyThumbWidthThreshold = targetHeight * WIDTH_TO_HEIGHT_RATIO_TO_SET_FOR_TINY;
    var tinyThumbHeightThreshold = targetHeight;
    item.width = Math.max(tinyThumbWidthThreshold, item.width);
    item.height = Math.max(tinyThumbHeightThreshold, item.height);
    return item;
};
export var getStyleParamsWithDefaultsOnce = function (defaults, nextProps, prevState) {
    // Only need to caclulate styleParams once
    if (prevState.layouter) {
        return prevState.layouter.styleParams;
    }
    // Get the layout config merged
    var layoutConfig = tslib_1.__assign({}, defaults.layoutConfig, nextProps.layoutConfig);
    var styleParams = {
        isColumnsLayout: false,
        allowedGroupTypes: ['1'],
        rowSize: 270,
        itemSpacing: 4,
    };
    // Set rowSize as our props have mobile vs desktop
    styleParams.rowSize = getRowSize(nextProps, layoutConfig);
    // Set the itemSpacing as our props have mobile vs desktop
    styleParams.itemSpacing = getItemSpacing(nextProps, layoutConfig);
    return styleParams;
};
function getRowSize(props, layoutConfig) {
    var isMobile = props.isMobile, useCardLayout = props.useCardLayout;
    if (useCardLayout) {
        return isMobile
            ? layoutConfig.rowSizeCardMobile
            : layoutConfig.rowSizeCardDesktop;
    }
    return isMobile ? layoutConfig.rowSizeMobile : layoutConfig.rowSizeDesktop;
}
function getItemSpacing(props, layoutConfig) {
    var isMobile = props.isMobile, useCardLayout = props.useCardLayout;
    if (useCardLayout) {
        return isMobile
            ? (layoutConfig.itemSpacingCardMobile || 8) / 2
            : (layoutConfig.itemSpacingCardDesktop || 16) / 2;
    }
    return isMobile
        ? (layoutConfig.itemSpacingMobile || 8) / 2
        : (layoutConfig.itemSpacingDesktop || 16) / 2;
}
export var didItemsChange = function (itemsA, itemsB) {
    if (itemsA && itemsA.length !== itemsB.length) {
        return true;
    }
    var total = (itemsA && itemsA.length) || 0;
    for (var i = 0; i < total; i++) {
        if (itemsA[i].id !== itemsB[i].id ||
            itemsA[i].width !== itemsB[i].width ||
            itemsA[i].height !== itemsB[i].height) {
            return true;
        }
    }
    return false;
};
export var propsItemsOrContainerHasChanged = function (nextProps, prevState) {
    if (!prevState || !prevState.container || !nextProps) {
        return true;
    }
    var _a = nextProps.items, nextItems = _a === void 0 ? [] : _a, nextContainerWidth = nextProps.container.width;
    var _b = prevState.items, prevItems = _b === void 0 ? [] : _b, prevContainerWidth = prevState.container.width;
    var dimChanged = prevContainerWidth !== nextContainerWidth;
    var itemChanged = didItemsChange(prevItems, nextItems);
    if (dimChanged || itemChanged) {
        return true;
    }
    return false;
};
export var stripHasRelatedContent = function (strip) {
    return strip.groups.reduce(function (has, group) {
        if (has === true ||
            group.items.find(function (i) { return i.dto.hasOwnProperty('renderRelatedContent'); })) {
            return true;
        }
        return false;
    }, false);
};
/**
 * Pro gallery does not handle extra height (footers in cards)
 * so we have to calculate our own group visibilities.
 *
 * This is a little bit of a monkey patch in that it modifies the
 * current layouter instance.
 */
export var calcVisibilities = function (layouter, bounds, optimSettings) {
    var stripExtraHeight = 0;
    for (var stripIdx = 0; stripIdx < layouter.strips.length; stripIdx++) {
        var strip = layouter.strips[stripIdx];
        for (var groupIdx = 0; groupIdx < strip.groups.length; groupIdx++) {
            var group = strip.groups[groupIdx];
            var rowHeight = group.height;
            var topExtra = 0;
            if (optimSettings && optimSettings.extraItemHeight) {
                // Adds the extra footer/header height to the row
                rowHeight += optimSettings.extraItemHeight;
                // For each row we move the top down based on the preceding rows
                // as this is always the same we simple multiply by row index
                topExtra = optimSettings.extraItemHeight * stripIdx;
                // This is used when hiding the strip so we have correct height
                // this is important to stop jumping and render loops
                strip.extraItemHeight = optimSettings.extraItemHeight;
            }
            if (stripExtraHeight) {
                // Somewhere above this row, height was added so we now need to
                // add that space to the top of the group
                topExtra = topExtra + stripExtraHeight;
            }
            // Top is the sum all the top adjustments
            // Bottom is the top + its height
            var top_1 = group.top + (bounds.offsetTop || 0) + topExtra;
            var bottom = top_1 + rowHeight;
            // Calculate the visibilies
            var onscreen = bottom >= bounds.onscreenTop && top_1 <= bounds.onscreenBottom;
            var visible = bottom >= bounds.visibleTop && top_1 <= bounds.visibleBottom;
            var rendered = bottom >= bounds.renderedTop && top_1 <= bounds.renderedBottom;
            // mutate the group and items
            group.onscreen = onscreen;
            group.visible = visible;
            group.rendered = rendered;
            for (var i = 0; i < group.items.length; i++) {
                group.items[i].visibility = {
                    onscreen: onscreen,
                    visible: visible,
                    rendered: rendered,
                };
            }
        }
        if (optimSettings && optimSettings.stripExtraHeight) {
            // We have a strip that has extra height, this means
            // it has either a content strip or related content, we
            // need to generally know the height of this additional content
            // because we need to offset the top of every row hereafter.
            //
            // Note that we do not add the extra height to the hidden strip
            // like we do for the header/footer extra, this is because we dont
            // hide the content/related items.
            if (optimSettings.stripExtraHeight[stripIdx]) {
                // Track the extra height so we can apply it to the top offsets
                stripExtraHeight += strip.extraHeight;
            }
        }
    }
};
//# sourceMappingURL=helpers.js.map